'use client';

import React, { useState } from 'react';
import { Send, Zap } from 'lucide-react';
import { Textarea , Button } from '@/components/ui';

export const NeuralIntake = () => {
  const [content, setContent] = useState('');
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncError, setSyncError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;

    setIsSyncing(true);
    setSyncError(null);
    try {
      const res = await fetch('/api/brain', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content, timestamp: new Date().toISOString() })
      });
      if (!res.ok) {
        setSyncError('Neural sync failed');
        return;
      }
      setContent('');
    } catch {
      setSyncError('Neural sync failed');
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <div className="bg-zinc-900/50 border border-white/5 rounded-2xl overflow-hidden backdrop-blur-xl group">
      <div className="p-4 border-b border-white/5 flex justify-between items-center bg-zinc-950/30">
        <div className="flex items-center gap-2">
           <Zap className={`w-3.5 h-3.5 ${isSyncing ? 'text-amber-500 animate-pulse' : 'text-zinc-500'}`} />
           <span className="text-[10px] font-black text-zinc-400 uppercase tracking-widest">Neural Intake</span>
        </div>
        <span className="text-[9px] font-mono text-zinc-500 uppercase">Buffer: Active</span>
      </div>
      
      <form onSubmit={handleSubmit} className="p-4">
        <Textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Dump thoughts, logic, or raw data here..."
          disabled={isSyncing}
        />
        {syncError && (
          <div className="text-xs text-rose-400 bg-rose-500/10 border border-rose-500/20 rounded-lg p-2 mt-2">{syncError}</div>
        )}
        <div className="mt-4 flex justify-between items-center pt-4 border-t border-white/5">
          <span className="text-[10px] font-mono text-zinc-500 uppercase">⌘ + ENTER TO COMMIT</span>
          <Button 
            type="submit"
            disabled={!content.trim() || isSyncing}
            className="flex items-center gap-2 bg-white text-zinc-950 px-4 py-1.5 rounded-lg text-[11px] font-black uppercase tracking-tight hover:bg-zinc-200 transition-colors active:scale-95 disabled:opacity-20"
          >
            {isSyncing ? 'Syncing...' : 'Commit to Neural'}
            <Send className="w-3 h-3" />
          </Button>
        </div>
      </form>
    </div>
  );
};
